import { compareCzech } from "@ckgo2/shared/utils";
import type { FacetBucket } from "./FacetPanel";

/**
 * Pořadí kbelíků v `FacetPanel`:
 * - `"count"` (výchozí): podle počtu sestupně, shoda drží pořadí z API; dnešní chování, kbelík
 *   `null` se řadí podle počtu jako ostatní;
 * - `"name"`: česky (`compareCzech`) podle TOHO, co panel vykreslí (`labelFor(value)`, bez
 *   `labelFor` hodnota) — faseta, jejíž popisek je jméno věci (destinace, země, člověk);
 * - `{ enum }`: v pořadí výčtu, hodnoty mimo výčet za ním (česky podle popisku).
 * U `"name"` a `{ enum }` je kbelík `null` vždy poslední.
 */
export type FacetOrder = "count" | "name" | { enum: readonly string[] };

/** Nové pole kbelíků v pořadí `order`; vstup se nemění. */
export function orderFacetBuckets(
  buckets: readonly FacetBucket[],
  order: FacetOrder = "count",
  labelFor?: (value: string) => string,
): FacetBucket[] {
  if (order === "count") return [...buckets].sort((a, b) => b.count - a.count);

  const label = (value: string) => (labelFor ? labelFor(value) : value);
  const byLabel = (a: string, b: string) => compareCzech(label(a), label(b));
  const rank =
    order === "name" ? null : new Map(order.enum.map((value, index) => [value, index] as const));

  return [...buckets].sort((a, b) => {
    if (a.value === null || b.value === null) {
      if (a.value === b.value) return 0;
      return a.value === null ? 1 : -1;
    }
    if (rank) {
      const ra = rank.get(a.value) ?? Number.POSITIVE_INFINITY;
      const rb = rank.get(b.value) ?? Number.POSITIVE_INFINITY;
      if (ra !== rb) return ra < rb ? -1 : 1;
    }
    return byLabel(a.value, b.value);
  });
}
